const NewsList2025 = [
     {
        dt: "July",
        my: "",
        link: "https://files.iittp.ac.in/2026/latest_news/best_Paper_Award_Certificate.pdf",
        title: "Best Paper Award",
        desc: <>Congratulations to Mr. Ritvik Ravi, B.Tech. (Mechanical Engineering) student of Dr.Govind Narayan Sahu has been awarded the Best Paper Award (Second Prize) at the International Conference on Intelligent Digital Technologies for Smart Manufacturing (ICIDTSM 2026), held at IIT Madras during July 20–22, 2026.</>
    }, 
    {
        dt: "Jan",
        my: "",
        link: "#",
        title: "Congratulations to Dr. Sarvendranath Rimalapudi - Grade of Senior Member of IEEE",
        desc: <>Congratulations to Dr. Sarvendranath Rimalapudi, Assistant Professor, Department of Electrical Engineering, IIT Tirupati, has been elevated to the grade of Senior Member of the Institute of Electrical and Electronics Engineers (IEEE).</>
    },
     {
        dt: "Nov",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/Awardees/2025/Mohanakkaviya.pdf",
        title: "Congratulations to Ms. I. Mohanakkaviya - Best Paper Presentation Award",
        desc: <>Congratulations to Ms. I. Mohanakkaviya, Ph.D. Research Scholar from the department of Chemical Engineering, working under the supervision of Prof. Anki Reddy Katha and Prof. Sasidhar Gumma, has received the Best Paper Presentation Award at IIChE CHEMCON 2025, organized by the Indian Institute of Chemical Engineers, Annamalai Regional Centre, at the International conference on “AI Driven Chemical Engineering Processes Transformation and Sustainability.”</>
    },
    {
        dt: "Nov",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/Awardees/2025/Dr_Ranjith_Thangavel_INAE.png",
        title: "Congratulations to Dr. Ranjith Thangavel - Young Associate of the Indian National Academy of Engineering (INAE)",
        desc: <>Congratulations to Dr. Ranjith Thangavel, Associate Professor, Department of Chemical Engineering, IIT Tirupati, on being elected as a Young Associate of the Indian National Academy of Engineering (INAE) and has been conferred with the INAE Young Engineer Award 2025.</>
    },
    {
        dt: "Nov",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/Awardees/2025/Prof_Muthukumar_INAE-Fellow.jpg",
        title: "Congratulations to Prof. Muthukumar Palanisamy - Fellow, Indian National Academy of Engineering",
        desc: <>Congratulations to Prof. Muthukumar Palanisamy, Professor, Department of Mechanical Engineering, IIT Tirupati, on being elected as a Fellow, Indian National Academy of Engineering (INAE), effective from 1 November 2025.</>
    },
     {
        dt: "Dec",
        my: "",
        link: "",
        title: "Congratulations to Dr. Sattwick Haldar",
        desc: <>Congratulations to Dr. Sattwick Haldar, Assistant Professor, Department of Chemistry, on being elected as an Associate of the Indian Academy of Sciences (IAS) for the next three years. This prestigious recognition honors his outstanding contributions as a Young Scientist and his impactful work in advancing chemical sciences.</>
    },
     {
        dt: "Dec",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/Awardees/2025/Prashanta_TCS.jpg",
        title: "Congratulations to Mr. Prashanta Bauri",
        desc: <>Congratulations to Mr. Prashanta Bauri (CY22D507), Ph.D. Research Scholar, Department of Chemistry, IIT Tirupati, for winning the Best Poster Presentation Award at the Theoretical Chemistry Symposium 2025, held at IIT Bombay (Dec 2–5, 2025).</>
    },
     {
        dt: "Dec",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/Awardees/2025/Pankaj_SMCB.jpg",
        title: "Congratulations to Mr. Pankaj Adhikary",
        desc: <>Congratulations to Mr. Pankaj Adhikary (CY22D506), Ph.D. Research Scholar, Department of Chemistry, IIT Tirupati, for winning the Best Poster Award! at "Statistical Mechanics in Chemistry and Biology - 2025", organised by TIFR Hyderabad (Dec 17-19, 2025). His work utilizes the vibrational signatures of water to demystify urea aggregation and assess urea force field accuracy.</>
    },
    {
        dt: "Nov",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/Awardees/2025/ysa_dr_bijily.jpg",
        title: "Congratulations to Dr. Bijily Balakrishnan - ICI Young Scientist Award 2025",
        desc: <>Congratulations to Dr. Bijily Balakrishnan, Associate Professor, Department of Civil & Environmental Engineering, IIT Tirupati, on receiving the prestigious Indian Concrete Institute (ICI) Young Scientist Award 2025.</>
    },
    {
        dt: "Nov",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/Awardees/2025/Pancha_DAAD_Res_Award_2025.png",
        title: "Congratulations to Dr. Panchatcharam Mariappan",
        desc: <>Congratulations to Dr. Panchatcharam Mariappan, Associate Professor, Department of Mathematics and Statistics, for receiving the DAAD Research Ambassador Award (2025-2028) for the second time a prestigious recognition awarded by the German Academic Exchange Service (DAAD). </>
    },
    {
        dt: "Oct",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/Awardees/2025/BKP_25_28.png",
        title: "Congratulations to Prof. Krishna Prapoorna Billigiri",
        desc: <>Congratulations to Prof. Krishna Prapoorna Billigiri, Professor, Department of Civil and Environmental Engineering, has been nominated as the Asphalt Rubber Ambassador for the Republic of India (2025–2028) by the Rubberized Asphalt Foundation (RAF).</>
    },
     {
        dt: "Oct",
        my: "",
        link: "",
        title: "Congratulations to Mr. Surendra Rajkumar G",
        desc: <>Congratulations to Mr. Surendra Rajkumar G (CH24D004), a research scholar in the Department of Chemical Engineering, IIT Tirupai under the supervision of Dr. Brindha Moorthy has been selected for the "Sakura Science Exchange Program (JST)" at Yokohama National University, Japan.</>
    },
     {
        dt: "Jul",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/Awardees/2025/Hazim_icRS_2025.pdf",
        title: "Congratulationss to Mr. Sheikh Hazim",
        desc: <>Congratulationss to Mr. Sheikh Hazim (CE23D001), a Ph.D Research scholar in the Department of Civil & Environmental Engineering, has been awarded a "Best Oral Presentation Award" under the theme "Sustainable Manufacturing and Industrial Innovations" at the International Conference on Resource Sustainability (icRS), held in Adelaide, Australia, from July 16–18, 2025.</>
    },
     {
        dt: "Jul",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/Awardees/2025/Bera_jacs.png",
        title: "Congratulations to Dr. Srikrishna Bera",
        desc: <>Dr. Srikrishna Bera, (Assistant Professor, Department of Chemistry) group has published a JACS article where they report <b>C(sp³)–N coupling of alkyl boronic esters via amino radical transfer and copper catalysis</b>. More details can be found at: https://pubs.acs.org/doi/10.1021/jacs.5c06042"</>
    },
     {
        dt: "May",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/Awardees/2025/Shihabudeen_Award_16_7_2025.jpg",
        title: "Congratulations to Prof. Shihabudheen M. Maliyekkal",
        desc: <>Prof. Shihabudheen M. Maliyekkal, (Professor, Department of Civil and Environmental Engineering) has been selected as the <b>Recipient of the Excellence in Research Award</b> under the <b>KPR Legacy Awards 2025</b>. This award recognizes his outstanding research contributions and was conferred upon him after a rigorous selection process involving over 1,200 applicants and 107 interviewed candidates.</>
    },
    {
        dt: "May",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/Awardees/2025/Prof_B_Krishna_Prapoorna_Awards_29_5_25.pdf",
        title: "Congratulations to Prof. B. Krishna Prapoorna",
        desc: <>Prof. B. Krishna Prapoorna, (Professor, Department of Civil and Environmental Engineering) has been conferred with two prestigious accolades by Springer Nature in May 2025 for his outstanding editorial contributions to the Journal of Innovative Infrastructure Solutions:<br />  <b>Editor of Distinction - Editorial Contribution Award</b> - In recognition of his impactful contributions towards the advancement and success of the journal.<br />
            <b>Editor of Distinction – Author Service Award</b> - For exemplary support and service to authors, upholding the highest editorial standards.</>
    },
    {
        dt: "April",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/Awardees/2025/Naga_Jyothi_RSC.jpg",
        title: "Congratulations to Ms. Priyanka V",
        desc: "Ms. Priyanka V, a first-year M.Tech student in the Department of Chemical Engineering at IIT Tirupati, has been selected for the prestigious DAAD KOSPIE scholarship to pursue a fully funded international research internship in Germany. Priyanka will be working on a project titled 'Piezoelectric Glycosaminoglycan Hydrogels for Cardiac Tissue Regeneration' at TU Darmstadt."
    },
    {
        dt: "April",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/Awardees/2025/Naga_Jyothi_RSC.jpg",
        title: "Congratulations to Ms. Aparna Surendran Nair",
        desc: "Ms. Aparna Surendran Nair, a first-year M.Tech student in the Department of Chemical Engineering at IIT Tirupati, has been selected for the prestigious Khorana Program for Scholars 2025. As part of this prestigious program, Aparna will pursue a summer research internship at Purdue University, USA."
    },
    {
        dt: "April",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/Awardees/2025/Naga_Jyothi_RSC.jpg",
        title: "Congratulations to Mr. Gnaneshwar Sampathirao",
        desc: "Congratulations to Mr. Gnaneshwar Sampathirao, a M.S. Research scholar in the Department of Chemical Engineering, has been awarded a poster presentation award at the Shaping the Energy Future: Challenges & Opportunities (SEFCO-2025) conference, held from April 23–25,Engineering Data (JCED)."
    },
     {
        dt: "April",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/Awardees/2025/Govardhana_Rekam_Best_Paper_Award_NIT_Raipur.jpg",
        title: "Congratulations to Mr. Govardhana Rekam",
        desc: "Mr. Govardhana Rekam, a Intern B-Tech student working under Dr. Govind N. Sahu, has secured the best paper award 'Title: AI-Enabled Automated Strabismus Detection and Corneal Deviation Analysis Using Image Processing Techniques' at the 3rd International Conference on Biomedical Engineering Science and Technology: Computational Methods in Biomedical Research (ICBEST 2025), April 10 - 11, 2025."
    },
    {
        dt: "March",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/Awardees/2025/Manuj_Certificate_best_presentation_award.pdf",
        title: "Congratulations to Mr. Manuj Sharma",
        desc: "Mr. Manuj Sharma, a PhD scholar from the Department of Civil and Environmental Engineering, has secured the 2nd prize in paper presentation titled: Assessment of Physio-Chemical Characteristics and Source Apportionment of Airborne Particulate Matter from the Construction Activities, at the International Conference on Air Quality Monitoring & Modelling (AQMM'25), organized by Kumaragaru College of Technology, Coimbatore, India, 19-20 March 2025."
    },
   
    {
        dt: "March",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/Awardees/2025/Naga_Jyothi_RSC.jpg",
        title: "Congratulations to Ms. M.S.V. Naga Jyothi",
        desc: "Ms M.S.V. Naga Jyothi, a PhD scholar from the Department of Civil and Environmental Engineering, has secured the Runner-up position in the Environmental Category at the 10th RSC (Royal Society of Chemistry) Global Online Poster Conference, held on the LinkedIn platform on March 4-5, 2025."
    },
   
    {
        dt: "March",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/announcements/2025/vajitha_award_ce21d501.jpg",
        title: "Congratulations to Ms. Vajitha G",
        desc: "Ms. Vajitha G, a Ph.D. scholar in Civil and Environmental Engineering, has been awarded First Prize for her project titled: 'A Continuous Flow Membrane-Modified Capacitive Deionization (MCDI) for Clean Drinking Water' under the Health Science category. This achievement was recognized at the All Indian Universities (AIU) ANVESHAN 2025 – International Research Student Convention, held at Chitkara University, Chandigarh on March 10 & 11, 2025."

    },
    {
        dt: "February",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/announcements/2025/CSE_MTECH_NEW.jpg",
        title: "Data Science and Artificial Intelligence'",
        desc: "Department of Computer Science and Engineering introduces a new stream in M.Tech programme - 'Data Science and Artificial Intelligence' from the Academic year 2025-26."
    },
    {
        dt: "February",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/announcements/2025/MA_MSC_MATHS.jpg",
        title: "M.Sc. In Mathematics",
        desc: "Department of Mathematics and Statistics introduces a new programme - 'M.Sc. in Mathematics' from the Academic year 2025-26."
    },
    {
        dt: "January",
        my: "",
        link: "https://files.iittp.ac.in/pdfs/announcements/2024/NPTEL_Public_Organization_and_Management_2025.png",
        title: "NPTEL course entitled 'Public Organization and Management'",
        desc: "Dr. Vaneet Kashyap from the HSS Department is offering an NPTEL course entitled 'Public Organization and Management'. The aim of the course is to introduce learners to various themes of managing public organisations and provide them with a greater depth of research and theory about public management. Intended audience: UG and PG students, civil servants, people working in government, public, and private sector organisations, and faculty teaching courses in general and public management."
    }
   


];


export default NewsList2025;
